import { css } from '@emotion/css';
import { N0, N50, primary, red , B400 } from '@assets/colors';

export const NotifBox = css`
  width: 360px;
`

const styles = {
  header: {
    height: 42,
    background: N0,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 99,
    boxShadow: '0 2px 4px 0 rgba(51, 51, 51, 0.16)',
  },
  leftSection: {
    width: 336,
    display: 'inline-block',
    padding: '4px 16px',
    borderRight: `solid 1px ${N50}`,
  },
  rightSection: {
    width: 'calc(100% - 336px)',
    paddingRight: 24,
    paddingLeft: 24,
    display: 'inline-block',
  },
  headerAltSection: {
    width: '100%',
    paddingRight: 24,
    paddingLeft: 24,
  },
  logo: {
    width: '82px',
    height: '32px',
    objectFit: 'contain',
  },
  menuIcon: {
    width: '24px',
    height: '24px',
    objectFit: 'contain',
    marginLeft: 8,
    marginRight: 8,
  },
  menuIconProfileImg: {
    objectFit: 'contain',
    borderRadius: '50%',
    cursor: 'pointer',
    width: 32,
    height: 32,
    marginTop: -5,
  },
  menuIconProfileImgActive: {
    objectFit: 'contain',
    borderRadius: '50%',
    cursor: 'pointer',
    width: 32,
    height: 32,
    border: `2px solid ${primary}`,
    marginTop: -5,
  },
  menuProfileContent: {
    height: 620,
  },
  menuProfileContentNoKyc: {
    height: 'calc(100vh - 270px)',
  },
  menuNotifContent: {
    height: 'calc(100vh - 270px)',
    marginBottom: 12,
  },
  menuCtaContent: {
    height: 'calc(100vh - 155px)',
    marginBottom: 16,
    cursor: 'pointer',
  },
  alertNotif: {
    width: 6,
    height: 6,
    borderRadius: '100%',
    backgroundColor: red,
    position: 'absolute',
    right: 12,
    top: 0,
  },
  underline: {
    textDecoration: 'underline'
  },
  cursorPointer: {
    cursor: 'pointer'
  },
  topLabel: {
    paddingTop:'3px',
    fontSize: '16px',
    fontWeight: 800
  },
  containerTopLabel: {
    display: 'flex',
    padding: '16px',
    paddingTop: '24px',
    justifyContent: 'space-between'
  },
};

export default styles;
